import React from "react"
import { FaArrowLeft, FaArrowRight, FaSearch } from "react-icons/fa"
import { Button, Loader, Table } from "../../../components/ui"
import { useRefundByStaff } from "../../../hooks/refund/useRefundByStaff"
import { formatDateTransactionDetail } from "../../../helper/formatDate"
import { formatRupiah } from "../../../helper/formatNumber"
import ReturFilter from "../components/ReturFilter"
import { ModalReturDetail } from "../components/ModalReturDetail"

/**
 * @typedef {import("../../../hooks/refund/useRefundByStaff").RefundByStaffPayload} RefundByStaffPayload
 */

export default function ReturList() {
  /** @type {[RefundByStaffPayload | null, React.Dispatch<React.SetStateAction<RefundByStaffPayload | null>>]} */
  const [filteredStaff, setFilteredStaff] = React.useState(null)

  const {
    data: refundData,
    isLoading,
    isNextPageActive,
    isPreviousPageActive,
    nextPage,
    previousPage,
  } = useRefundByStaff(filteredStaff)

  const [isShowModalDetail, setIsShowModalDetail] = React.useState(false)
  const [returDetail, setReturDetail] = React.useState(null)

  /**
   * @param {import("../components/ReturFilter").ReturFilterData} data 
   */
  const handleFilter = (data) => {
    setFilteredStaff({
      staff_id: data.staff?.id,
      start_date: data.dateRange.start,
      end_date: data.dateRange.end,
    })
  }

  const openModalReturDetail = (refundData) => {
    setIsShowModalDetail(true)
    setReturDetail(refundData)
  }

  const closeModalReturDetail = () => {
    setIsShowModalDetail(false)
    setReturDetail(null)
  }

  return (
    <React.Fragment>
      <h1 className="mb-4">Daftar Retur</h1>
      <ReturFilter
        onFilter={handleFilter}
      />
      <div className="mb-4">
        <Table striped>
          <thead>
            <tr>
              <th>Tanggal Transaksi</th>
              <th>Tanggal Retur</th>
              <th>Nama Staff</th>
              <th>Pasien</th>
              <th>Total Transaksi</th>
              <th style={{ width: '400px' }}>Alasan Retur</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  <Loader title="Sedang memuat data, mohon tunggu..." />
                </td>
              </tr>
            ) : (
              refundData.length > 0 ? (
                refundData.map((refund) => (
                  <tr key={refund.transaction_refund_id}>
                    <td>{formatDateTransactionDetail(refund.product_transaction_date)}</td>
                    <td>{formatDateTransactionDetail(refund.transaction_refund_date)}</td>
                    <td>{refund.staff_name}</td>
                    <td>{refund.patient_name ? refund.patient_name : "-"}</td>
                    <td>{formatRupiah(refund.total_transaction)}</td>
                    <td>{refund.refund_reason ? refund.refund_reason : "-"}</td>
                    <td>
                      <Button
                        variant="primary"
                        size="icon-sm"
                        onClick={() => openModalReturDetail(refund)}
                      >
                        <FaSearch />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} style={{ textAlign: "center" }}>Data tidak tersedia</td>
                </tr>
              )
            )}
          </tbody>
        </Table>
      </div>
      {refundData.length > 0 ? (
        <div className="flex justify-end space-x-4">
          <Button
            variant="primary"
            disabled={!isPreviousPageActive}
            onClick={() => previousPage()}
          >
            <FaArrowLeft className="mr-2" />
            Sebelumnya
          </Button>
          <Button
            variant="primary"
            disabled={!isNextPageActive}
            onClick={() => nextPage()}
          >
            Selanjutnya
            <FaArrowRight className="ml-2" />
          </Button>
        </div>
      ) : null}

      <ModalReturDetail
        isShowModal={isShowModalDetail}
        returDetail={returDetail}
        onClose={closeModalReturDetail}
      />
    </React.Fragment>
  )
}
